import { Users } from '../../services';
import { createRestSlices, createGenericSlice, applyReducers } from './rest';

const {
    initialState,
    createReducer,
    startCreateReducer,
    getReducer,
    listReducer,
    updateReducer,
    deleteReducer,
    startCreateAction: startCreateUser,
    createAction: createUser,
    getAction: loadUser,
    listAction: loadUsers,
    updateAction: updateUser,
    deleteAction: deleteUser,
} = createRestSlices(Users);

// enable user slice
const { reducer: enableReducer, action: enableUser } = createGenericSlice(Users, {
    name: 'enableUser',
    action: (id) => Users.enable(id),
    onSuccess: (state, action) => ({ ...state, user: action.user }),
    onError: (state, error) => ({ ...state }),
});

// disable user slice
const { reducer: disableReducer, action: disableUser } = createGenericSlice(Users, {
    name: 'disableUser',
    action: (id) => Users.disable(id),
    onSuccess: (state, action) => ({ ...state, user: action.user }),
    onError: (state, error) => ({ ...state }),
});

// load inactive users slice
const { reducer: loadInactiveReducer, action: loadInactiveUsers } = createGenericSlice(Users, {
    name: 'loadInactiveUsers',
    action: () => Users.inactive(),
    onSuccess: (state, action) => ({ ...state, inactive_users: action.users }),
    onError: (state, error) => ({ ...state }),
});

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [ createReducer, startCreateReducer, getReducer, listReducer, updateReducer, deleteReducer, enableReducer, disableReducer, loadInactiveReducer ]);
}

/* Export CRUD actions */
export {
    createUser,
    startCreateUser,
    loadUser,
    loadUsers,
    updateUser,
    deleteUser,
    disableUser,
    enableUser,
    loadInactiveUsers
};
